import { classNames } from '@fullstory/util/fmt';
import React, { ComponentPropsWithoutRef } from 'react';
import { Button } from '../../components/Button';
import { identifyComponent } from '../../util';
import css from './index.module.scss';

export interface ToggleButtonProps
  extends Omit<ComponentPropsWithoutRef<typeof Button>, 'onClick' | 'variant'> {
  selected: boolean;
  onChange: () => void;
}

export const ToggleButton: React.FC<ToggleButtonProps> = ({ selected, onChange, ...rest }) => (
  <Button
    data-component="ToggleButton"
    variant="outline"
    className={classNames({ [css.selected]: selected })}
    onClick={onChange}
    {...rest}
    {...identifyComponent('toggle-button', rest)}
  />
);
